import AuthService from '../_services/auth.service'

let user = JSON.parse(localStorage.getItem('user'))

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      //console.log(user)
      return AuthService.login(user).then(
        (respond) => {
          if (respond.status == 'success') {
            commit('loginSuccess', respond.data)
            return Promise.resolve(respond.data)
          } else {
            commit('loginFailure')
            return Promise.reject(respond.message)
          }
        },
        (error) => {
          commit('loginFailure')
          return Promise.reject(error)
        },
      )
    },
    logout({ commit }) {
      commit('logout')
      return
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure(state) {
      state.status.loggedIn = false
      state.user = null
      AuthService.logout()
    },
    logout(state) {
      state.status.loggedIn = false
      state.user = null
      AuthService.logout()
    },
  },
}
